import React from 'react'

import Base from '../../_Base'

const Twitter16 = (props) => (
  <Base
    aria-hidden="true"
    focusable="false"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      d="M5 14.5a9.28 9.28 0 0 0 9.34-9.34v-.42A6.68 6.68 0 0 0 16 3a6.55 6.55 0 0 1-1.89.52 3.29 3.29 0 0 0 1.44-1.82 6.58 6.58 0 0 1-2.08.8 3.29 3.29 0 0 0-5.59 3 9.32 9.32 0 0 1-6.77-3.4 3.29 3.29 0 0 0 1 4.38 3.26 3.26 0 0 1-1.47-.41 3.28 3.28 0 0 0 2.64 3.26 3.28 3.28 0 0 1-1.48.06 3.29 3.29 0 0 0 3.07 2.28 6.59 6.59 0 0 1-4.09 1.4A6.68 6.68 0 0 1 0 13a9.29 9.29 0 0 0 5 1.5"
      fillRule="evenodd"
    />
  </Base>
)

export default Twitter16
